module.exports = __webpack_public_path__ + "static/img/empty.e5097d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedbacks/empty.jpg
// module id = ZvAE
// module chunks = 0